var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavewhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.9987H13.013C12.7217 7.99807 12.4381 8.0929 12.2058 8.26868C11.9734 8.44445 11.805 8.6915 11.7263 8.97203L10.1597 14.5454C10.1496 14.58 10.1285 14.6104 10.0997 14.632C10.0708 14.6537 10.0357 14.6654 9.99967 14.6654C9.96361 14.6654 9.92852 14.6537 9.89967 14.632C9.87083 14.6104 9.84977 14.58 9.83967 14.5454L6.15967 1.45203C6.14958 1.41741 6.12852 1.387 6.09967 1.36536C6.07083 1.34373 6.03574 1.33203 5.99967 1.33203C5.96361 1.33203 5.92852 1.34373 5.89967 1.36536C5.87083 1.387 5.84977 1.41741 5.83967 1.45203L4.27301 7.02536C4.19465 7.3048 4.02726 7.55104 3.79625 7.72671C3.56524 7.90237 3.28322 7.99787 2.99301 7.9987H1.33301",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavewhite);
export default __webpack_public_path__ + "static/media/wavewhite.261c5bfc775d65db7f0bd295d496046e.svg";
export { ForwardRef as ReactComponent };